import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "20",
      height: "20",
      rx: "4",
      fill: "#333333"
    }, null, -1),
    _createElementVNode("path", {
      d: "M11.0368 4.86451L12.0927 6.9936C12.2367 7.28998 12.6207 7.57427 12.9446 7.6287L14.8584 7.94928C16.0823 8.15493 16.3702 9.05012 15.4883 9.93321L14.0005 11.4333C13.7485 11.6873 13.6105 12.1772 13.6885 12.5281L14.1145 14.385C14.4504 15.8548 13.6765 16.4233 12.3867 15.6552L10.5929 14.5846C10.2689 14.391 9.73497 14.391 9.40501 14.5846L7.6112 15.6552C6.32735 16.4233 5.54743 15.8487 5.8834 14.385L6.30935 12.5281C6.38734 12.1772 6.24936 11.6873 5.99738 11.4333L4.50955 9.93321C3.63364 9.05012 3.91561 8.15493 5.13948 7.94928L7.05327 7.6287C7.37123 7.57427 7.75519 7.28998 7.89917 6.9936L8.95506 4.86451C9.53099 3.70923 10.4669 3.70923 11.0368 4.86451Z",
      stroke: "white",
      "stroke-opacity": "0.7",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }